module.exports = __webpack_public_path__ + "media/images/illustrations/bedframe-af9b3441c19813b52718759829ebd338.svg";